import React, { useState, useEffect, useRef } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import MainWrapper from "../layouts/MainWrapper";
import CardWrapper from "../layouts/CardWrapper";
import Image from "react-bootstrap/Image";
import PageTitle from "../components/PageTitle";
import CustomBreadcrumb from "../components/CustomBreadcrumb";
import Dropdown from "react-bootstrap/Dropdown";
import Form from "react-bootstrap/Form";
import Tabs from "../components/Tabs/Tabs";
import InboxDetailsPanel from "../components/DetailsPanel/InboxDetailsPanel";
import { getInboxList } from "../services/supportService";
import { useAlert } from "../contexts/AlertContext";
import scrollIntoView from "scroll-into-view-if-needed";
import { useAtomValue } from "jotai";
import { authAtom } from "../states/auth";
import eventBus from "../utils/eventBus";
import { singleUser } from "../services/userService";

const getHourMinuteDiffString = (date1, date2) => {
  const msDiff = Math.abs(date2 - date1);
  const totalMinutes = Math.floor(msDiff / (1000 * 60));
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (hours === 0) {
    return `${minutes}m`;
  } else if (minutes === 0) {
    return `${hours}h`;
  } else {
    return `${hours}h ${minutes}m`;
  }
};

const formatDate = (date) => {
  if (!date) return "From - To Date";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const year = date.getFullYear();

  return `${year}-${month}-${day}`;
};

const Inbox = () => {
  const inboxTimerRef = useRef(null);
  const heartbeatRef = useRef(null);
  const lastNowRef = useRef(Date.now());
  const latestInboxDataRef = useRef([]);

  const [selectedItem, setSelectedItem] = useState(null);
  const selectedItemRef = useRef(null);
  const rowHandler = (item) => {
    setSelectedItem(item);
    document.body.classList.add("sidebar-collapsed");
  };
  const BeadcrumbItems = [{ label: "Inbox", active: true }];
  const tabItem = { All: "all", Chat: "chats", Video: "video" };
  const [inboxList, setInboxList] = useState([]);
  const [loginUserId, setLoginUserId] = useState(null);
  const [showStatusDropdown, setShowStatusDropdown] = useState(false);
  const { showAlert } = useAlert();
  const hasScrolled = useRef(false);
  const dateRefs = useRef({});
  const containerRef = useRef(null);
  const auth = useAtomValue(authAtom);
  const [inboxFilterObject, setInboxFilterObject] = useState({
    // date: new Date(),
    no_of_result: 200,
    page: 1,
    inboxSupportType: "all",
    inboxFilter: "all",
  });

  const showLabel = {
    new: "New",
    expired: "Expired",
    all: "Filter",
  };

  const changeInboxFilterCriteriaByName = (name, value) => {
    setInboxFilterObject((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    selectedItemRef.current = selectedItem;
  }, [selectedItem]);

  const identifyUser = (data, auth) => {
    let userMeta = { label: "", image: "", role: "" };
    if (data?.createdBy?.roleId == 3) {
      console.log("login user----------->", data?.createdBy?.createdBy, auth);
      if (data?.conversationType == "internal call") {
        userMeta = {
          label: "Expert",
          role: "expert",
          image: "/images/user-circle-yellow.svg",
        };
      } else if (data?.createdBy?.createdBy.id !== auth) {
        userMeta = {
          label: "Contact",
          role: "client",
          image: "/images/user-circle-gear-blue.svg",
        };
      } else {
        userMeta = {
          label: "External Expert",
          role: "external_expert",
          image: "/images/user-circle-dashed-red.svg",
        };
      }
    } else if (data?.createdBy?.roleId == 5) {
      userMeta = {
        label: "Contact",
        role: "client",
        image: "/images/user-circle-gear-blue.svg",
      };
    } else if (data?.createdBy?.roleId == 2) {
      if (data?.createdBy?.createdBy === data?.createdBy?.id) {
        userMeta = {
          label: "User",
          role: "internal_user",
          image: "/images/user-circle-yellow.svg",
        };
      } else {
        userMeta = {
          label: "User",
          role: "external_user",
          image: "/images/user-circle-yellow.svg",
        };
      }
    }
    return userMeta;
  };
  useEffect(() => {
    singleUser(auth?.user?.id).then((response) => {
      if (response?.data?.user) {
        const UserData = response?.data?.user;
        let loginUserId =
          UserData?.roleId === 2 ? UserData?.id : UserData?.createdBy?.id;
        setLoginUserId(loginUserId);
      }
    });
  }, [auth?.user]);

  const groupByDatesAndSort = (data, showAllDates = true) => {
    const grouped = {};

    // Step 2: Fill in sessions if they exist
    data?.forEach((item) => {
      const dateKey = new Date(
        item.startTime || item.createdAt,
      ).toLocaleDateString("en-CA");
      if (!grouped[dateKey]) {
        grouped[dateKey] = []; // fallback, in case the date is somehow outside the range
      }
      grouped[dateKey].push(item);
    });

    const dateKey = new Date().toLocaleDateString("en-CA");

    if (!grouped[dateKey]) {
      grouped[dateKey] = [];
    }
    console.log("grouping", grouped);
    return grouped;
  };

  // useEffect(() => {
  //   if (!inboxList || hasScrolled.current) return;

  //   const todayStr = formatDate(new Date())
  //   const allDates = Object.keys(groupByDatesAndSort(inboxList));

  //   const scrollToDate = allDates.includes(todayStr) ? todayStr : allDates[0];

  //   const el = dateRefs.current[scrollToDate];
  //   console.log("el",el)
  //   if (el) {
  //     scrollIntoView(el, {
  //       behavior: "smooth",
  //       scrollMode: "always",
  //       block: "start",
  //       // inline: "nearest",
  //     });
  //     hasScrolled.current = true; // Mark as scrolled to prevent future scrolls

  //   }
  // }, [inboxList]);

  useEffect(() => {
    latestInboxDataRef.current = inboxList || [];

    if (!inboxList || hasScrolled.current) return;

    const groupedData = groupByDatesAndSort(inboxList);
    const todayStr = formatDate(new Date());
    const allDates = Object.keys(groupedData);
    const scrollToDate = allDates.includes(todayStr) ? todayStr : allDates[0];
    const el = dateRefs.current[scrollToDate];

    if (el && containerRef.current) {
      const container = containerRef.current;
      const scrollOffset = el.offsetTop;

      container.scrollTo({
        top: scrollOffset,
        behavior: "smooth",
      });

      hasScrolled.current = true;
    }
  }, [inboxList]);

  const getInboxData = async () => {
    try {
      console.log("Fetching inbox with filter:", inboxFilterObject);

      const response = await getInboxList(inboxFilterObject);
      console.log("inboxxx", response);

      setInboxList(response?.data);

      scheduleNextInboxRefresh(response?.data);

      const stillExists =
        selectedItem &&
        response?.data?.some((item) => item.id === selectedItem.id);

      if (!stillExists) {
        setSelectedItem(null);
      }
    } catch (error) {
      console.error("Error fetching inbox:", error);
      showAlert({
        title: "Contact Notification",
        message: error?.response?.data?.message ?? "Something went wrong",
        variant: "danger",
      });
    }
  };

  const scheduleNextInboxRefresh = (list) => {
    if (!list || list.length === 0) return;

    const now = Date.now();
    let nextBoundary = null;

    list.forEach((item) => {
      const start = item.startTime ? new Date(item.startTime).getTime() : null;
      const end = item.endTime ? new Date(item.endTime).getTime() : null;

      if (start && start > now) {
        if (!nextBoundary || start < nextBoundary) nextBoundary = start;
      }
      if (end && end > now) {
        if (!nextBoundary || end < nextBoundary) nextBoundary = end;
      }
    });

    if (nextBoundary) {
      const delay = Math.max(nextBoundary - now, 0);

      console.log("next delay in", delay);

      if (inboxTimerRef.current) clearTimeout(inboxTimerRef.current);

      inboxTimerRef.current = setTimeout(() => {
        console.log("⚡ Inbox boundary reached → refreshing");
        setInboxList((prev) => [...(prev || [])]); // trigger re-render
        scheduleNextInboxRefresh(latestInboxDataRef.current); // schedule again
      }, delay);
    }
  };

  useEffect(() => {
    heartbeatRef.current = setInterval(() => {
      const now = Date.now();
      const diff = now - lastNowRef.current;
      lastNowRef.current = now;

      if (Math.abs(diff - 5000) > 2000) {
        // drift > 2s
        console.log("⚠️ Clock changed → rescheduling inbox timers");
        if (inboxTimerRef.current) clearTimeout(inboxTimerRef.current);
        scheduleNextInboxRefresh(latestInboxDataRef.current);
      }
    }, 5000);

    return () => {
      if (heartbeatRef.current) clearInterval(heartbeatRef.current);
      if (inboxTimerRef.current) clearTimeout(inboxTimerRef.current);
    };
  }, []);

  const handleNewConversation = (data) => {
    console.log("Incoming support request:", data);

    setInboxList((prevList) => {
      const exists = prevList?.some((item) => item.id === data.id);

      const newList = exists
        ? prevList.map((item) => (item.id === data.id ? data : item))
        : [data, ...(prevList || [])];

      scheduleNextInboxRefresh(newList);

      return newList;
    });
  };

  const handleUpdateConversation = (data) => {
    console.log("Update support request:", data);

    if (selectedItemRef.current?.id == data.id) {
      setSelectedItem(data);
    }

    setInboxList((prevList) => {
      const exists = prevList?.some((item) => item.id === data.id);

      const newList = exists
        ? prevList.map((item) => (item.id === data.id ? data : item))
        : [data, ...(prevList || [])];

      // ✅ Reschedule timers with updated list
      scheduleNextInboxRefresh(newList);

      return newList;
    });
  };

  const handleEndConversation = (data) => {
    console.log("END_SUPPORT_REQUEST received for ID:", data.id);

    if (selectedItemRef.current?.id == data.id) {
      setSelectedItem(null);
    }

    setInboxList((prevList) => {
      const newList = prevList
        ? prevList.filter((item) => item.id !== data.id)
        : [];

      // ✅ Reschedule timers with updated list
      scheduleNextInboxRefresh(newList);

      return newList;
    });
  };

  useEffect(() => {
    eventBus.on("NEW_SUPPORT_REQUEST", handleNewConversation);
    eventBus.on("RESCHEDULED_UPDATE_EVENT", handleUpdateConversation);
    eventBus.on("END_SUPPORT_REQUEST", handleEndConversation);

    return () => {
      eventBus.off("NEW_SUPPORT_REQUEST", handleNewConversation);
      eventBus.off("RESCHEDULED_UPDATE_EVENT", handleUpdateConversation);
      eventBus.off("END_SUPPORT_REQUEST", handleEndConversation);
    };
  }, []);

  useEffect(() => {
    if (!auth?.token) {
      console.warn("🔐 Token not available yet. Skipping API call.");
      return;
    }

    const fetchData = async () => {
      await getInboxData();
    };

    fetchData();
  }, [inboxFilterObject, auth?.token]); // <-- watch for token readiness

  return (
    <>
      <div className="mb-4">
        <CustomBreadcrumb items={BeadcrumbItems} />
        <PageTitle title="Inbox" />
      </div>
      <MainWrapper>
        <CardWrapper className="p-0">
          <div className="p-3 border-bottom">
            <Row className="align-items-center gy-4 gy-lg-0">
              <Col lg="6">
                <Tabs
                  tabItem={tabItem}
                  changeFunction={changeInboxFilterCriteriaByName}
                  changeValue={"inboxSupportType"}
                  className="md"
                />
              </Col>
              <Col lg="6">
                <Dropdown
                  show={showStatusDropdown}
                  onToggle={(isOpen) => setShowStatusDropdown(isOpen)}
                  className="text-end"
                >
                  <Dropdown.Toggle
                    variant="outline-secondary"
                    className="btn-sm dropdown-toggle-none d-inline-flex align-items-center gap-1 shadow-none"
                    align="end"
                  >
                    <Image
                      src={
                        showStatusDropdown
                          ? "/images/funnel-line-white.svg"
                          : "/images/funnel-line.svg"
                      }
                      alt="Filter Icon"
                      className="filter-icon"
                    />
                    {showLabel[inboxFilterObject.inboxFilter]}
                  </Dropdown.Toggle>

                  <Dropdown.Menu
                    className="filter-dropdown-menu dropdown-menu-end p-0"
                    align="end"
                    popperConfig={{
                      modifiers: [
                        {
                          name: "offset",
                          options: { offset: [0, 5] },
                        },
                      ],
                    }}
                  >
                    <div className="px-3 pt-2 border-bottom">
                      <Form.Check
                        className="radio-primary mb-2"
                        type="radio"
                        label="Select All"
                        name="inboxFilter"
                        onChange={() =>
                          changeInboxFilterCriteriaByName("inboxFilter", "all")
                        }
                        value="all"
                        id="checkbox-all"
                        checked={inboxFilterObject.inboxFilter === "all"}
                      />
                    </div>
                    <div className="px-3 pt-2 pb-2 border-bottom">
                      <Form.Check
                        className="radio-primary mb-2"
                        type="radio"
                        label="New"
                        value="new"
                        onChange={() =>
                          changeInboxFilterCriteriaByName("inboxFilter", "new")
                        }
                        name="inboxFilter"
                        id="checkbox-new"
                        checked={inboxFilterObject.inboxFilter === "new"}
                      />
                      <Form.Check
                        className="radio-primary mb-1"
                        type="radio"
                        label="Expired"
                        onChange={() =>
                          changeInboxFilterCriteriaByName(
                            "inboxFilter",
                            "expired",
                          )
                        }
                        value="expired"
                        name="inboxFilter"
                        id="checkbox-expired"
                        checked={inboxFilterObject.inboxFilter === "expired"}
                      />
                    </div>
                    <div className="p-2 d-flex align-items-center justify-content-between">
                      <button
                        onClick={(e) => {
                          setShowStatusDropdown(false);
                          changeInboxFilterCriteriaByName("inboxFilter", "all");
                        }}
                        className="btn btn-xm btn-reset text-blue"
                      >
                        Reset
                      </button>
                      <button
                        onClick={() => setShowStatusDropdown(false)}
                        className="btn btn-xm btn-blue"
                      >
                        Okay
                      </button>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
            </Row>
          </div>
          <div className="full-box p-3" ref={containerRef}>
            {inboxList && Object.keys(inboxList).length === 0 && (
              <div className="session-item bg-white cursor-auto border-grey-300 d-flex align-align-items-center justify-content-center mb-3">
                <p className="d-flex align-items-center fs-16 fw-500 text-gray-400 text-center mb-0">
                  No Events Available
                </p>
              </div>
            )}
            {inboxList &&
              Object.entries(groupByDatesAndSort(inboxList, false))
                .sort(([a], [b]) => new Date(a) - new Date(b)) // sort by ascending date
                .map(
                  ([date, sessions]) =>
                    sessions.length > 0 && (
                      <div
                        className="session-item-group"
                        key={date}
                        ref={(el) => (dateRefs.current[date] = el)}
                      >
                        <p className="text-gray-500 fs-15 fw-semibold mb-2">
                          {new Date(date).toLocaleDateString("en-US", {
                            weekday: "long",
                            month: "short",
                            day: "numeric",
                            timeZone: "UTC",
                          })}
                        </p>
                        {sessions
                          .sort(
                            (a, b) =>
                              new Date(a.startTime ?? a.createdAt) -
                              new Date(b.startTime ?? b.createdAt),
                          )
                          .map((session) => {
                            const userMeta = identifyUser(session, loginUserId);
                            return (
                              <div
                                onClick={() => rowHandler(session)}
                                className={`session-item radius-12 ${selectedItem?.id === session?.id ? "active" : ""}`}
                                key={session?.id}
                              >
                                <div className="session-info">
                                  <Image
                                    src={
                                      session.conversationType.includes("chat")
                                        ? "/images/chat-circle-text.svg"
                                        : "/images/video-camera.svg"
                                    }
                                    width={32}
                                    height={32}
                                    alt="Chat Circle Text Icon"
                                  />
                                  <p className="text-gray-700 fs-12 fw-semibold mt-2 mb-0">
                                    {new Date(
                                      session.startTime || session.createdAt,
                                    ).toLocaleTimeString([], {
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      hour12: true,
                                    })}{" "}
                                    {session.startTime && session.endTime && (
                                      <span className="d-inline-block fw-normal ms-1">
                                        (
                                        {getHourMinuteDiffString(
                                          new Date(session.endTime),
                                          new Date(session.startTime),
                                        )}
                                        )
                                      </span>
                                    )}
                                  </p>
                                </div>
                                <div className="session-details col">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <h3 className="fs-14 mb-1">
                                      {session?.createdBy?.companyName}
                                    </h3>
                                    {(session.conversationType.includes(
                                      "call",
                                    ) &&
                                      session?.startTime &&
                                      new Date(session?.startTime) <
                                        new Date() && (
                                        <span className="badge expired">
                                          Expired
                                        </span>
                                      )) || (
                                      <span className="badge new">New</span>
                                    )}
                                  </div>
                                  <p className="fs-12 fw-500 text-gray-600 mb-0">
                                    {session?.expertise?.name}
                                  </p>
                                  <ul className="d-flex align-items-center gap-2 list-unstyled mt-2 mb-0">
                                    <li className="d-flex align-items-center gap-1">
                                      <Image
                                        src={
                                          userMeta?.image ||
                                          "/images/user-circle-gear-blue.svg"
                                        }
                                        width={20}
                                        height={20}
                                        alt="User Circle Gear Icon"
                                      />
                                      <span className="fs-12 text-gray-500">
                                        {userMeta.label}:{" "}
                                        {session?.createdBy?.firstName || ""}{" "}
                                        {session?.createdBy?.lastName || ""}
                                      </span>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    ),
                )}
            {/* <div style={{ minHeight: "100%" }} /> */}
          </div>
        </CardWrapper>
        <InboxDetailsPanel
          item={selectedItem}
          inboxList={inboxList}
          setInboxList={setInboxList}
          getInboxData={() => getInboxData()}
          loggedInUser={auth}
          isOpen={!!selectedItem}
          onSidebarClose={() => setSelectedItem(null)}
        />
      </MainWrapper>
    </>
  );
};

export default Inbox;
